export default async function deleteNotificationChannelAsync(channelId: string): Promise<void> {
  console.debug('Notification channels feature is only supported on Android.');
}
